import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import styles from './LayerItemText.styles';
const useStyles = makeStyles(styles);

const LayerItemText = ({ layerId, layer, squareFootage }) => {
  const classes = useStyles();
  const getLabel = () => {
    if(layer && layer.layerOption && layer.layerOption.name){
      return layer.layerOption.name;
    } else if(layer && layer.layerType === 'baseLayer'){
      return 'Base Layer';
    }
    return `Layer ${layerId || ''}`;
  }
  return (
    <Grid container className={classes.layerItemText}>
      <Grid item className={classes.textContainer}>
        <span className={classes.label}>{getLabel()}</span>
        <span className={classes.sqFt}>Sq Ft. {squareFootage}</span>
      </Grid>
    </Grid>
  );
};
LayerItemText.propTypes = {
  layerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  squareFootage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LayerItemText;
